import { Link, useNavigate } from 'react-router-dom';
import { Trophy, LogOut, Shield } from 'lucide-react'; // Removed Swords since we are using an image
import { Button } from './ui/button';
import { getAuth, clearAuth } from '../utils/auth';

export default function Navbar() {
  const navigate = useNavigate();
  const { user } = getAuth();

  const handleLogout = () => {
    clearAuth();
    navigate('/login');
  };

  // Replace this string with your actual logo URL
  const logoUrl = "https://i.postimg.cc/S2D4JgWq/mallurealmfav.png";

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-white/5 backdrop-blur-xl bg-black/40">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          
          {/* Logo Section */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img 
              src={logoUrl} 
              alt="MalluRealm Logo" 
              className="w-9 h-9 object-contain" // Adjusted size slightly for better visibility
            />
            <span className="text-2xl font-black tracking-tighter uppercase" style={{fontFamily: 'Unbounded, sans-serif'}}>
              Mallu<span className="text-[#00E055]">Realm</span>
            </span>
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/servers" className="text-sm font-medium hover:text-[#00E055] transition-colors" data-testid="nav-servers">
              SERVERS
            </Link>
            <Link to="/leaderboard" className="flex items-center gap-2 text-sm font-medium hover:text-[#00E055] transition-colors" data-testid="nav-leaderboard">
              <Trophy className="w-4 h-4" />
              LEADERBOARD
            </Link>

            {user ? (
              <>
                {(user.role === 'server_owner' || user.role === 'admin') && (
                  <Link to="/dashboard" className="text-sm font-medium hover:text-[#00E055] transition-colors" data-testid="nav-dashboard">
                    DASHBOARD
                  </Link>
                )}
                {(user.role === 'admin' || user.email === 'owner@mallurealm.com') && (
                  <Link to="/admin" className="flex items-center gap-2 text-sm font-medium hover:text-[#00E055] transition-colors" data-testid="nav-admin">
                    <Shield className="w-4 h-4" />
                    ADMIN
                  </Link>
                )}
                <Button
                  onClick={handleLogout}
                  variant="ghost"
                  size="sm"
                  className="gap-2"
                  data-testid="logout-button"
                >
                  <LogOut className="w-4 h-4" />
                  LOGOUT
                </Button>
              </>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="ghost" size="sm" data-testid="login-button">
                    LOGIN
                  </Button>
                </Link>
                <Link to="/register">
                  <Button size="sm" className="bg-[#00E055] hover:bg-[#00E055]/90 text-black font-bold glow-primary" data-testid="register-button">
                    REGISTER
                  </Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
